<section
    [id]="id()"
    class="relative w-full h-full"
    [attr.data-testid]="currentTestId()"
    [attr.data-styletarget]="id()"
>
    <section
        [attr.data-uitype]="'graph-legend'"
        class="flex justify-between items-center pl-[80px] sm:pl-[25px] py-4 text-dat-grey-200"
    >
        <h3 class="font-headline-5 sm:text-xs">Flatbed Load-to-Truck Ratio</h3>
        <div class="flex items-center pr-[20px]">
            <span
                class="rounded-full h-6 w-6 sm:h-4 sm:w-4 bg-[#BA61EB] inline-block mx-4 sm:mx-2"
            ></span>
            <label class="mr-4 font-headline-5 sm:text-xs"> {{ currentYear }}</label>
            <span
                class="rounded-full h-6 w-6 mx-4 bg-[#00d000] inline-block mr-2 sm:h-4 sm:w-4"
            ></span>
            <label class="font-headline-5 mr-4 sm:text-xs">{{ lastYear }}</label>
            <span
                class="rounded-full h-6 w-6 mx-4 bg-[#e10600] inline-block mr-2 sm:h-4 sm:w-4"
            ></span>
            <label class="font-headline-5 mr-4 sm:text-xs">{{ lastTwoYear }}</label>
        </div>
    </section>
    <section
        [attr.data-testid]="id() + '-graph'"
        [attr.data-styletarget]="id() + '-graph'"
        [attr.data-uitype]="'graph'"
        class="w-full h-full"
        #graph
    ></section>
</section>
<div [attr.data-json-info]="'lt-ratios-flatbed'" class="hidden">
    {{ data() | json }}
</div>
<meta name="description" [content]="data() | json" />